<template>
  <div class="verify" v-if="isLogged" v-wechat-title="$route.meta.title">
    <header v-if="!isAPP">
      <div class="left" @click="goBack">
        <img src="../../../image/arrows.png" />
      </div>
      <div class="text">更换手机号码</div>
    </header>
    <div class="tip-text">{{ tipText }}</div>
    <div v-if="isShowImgCaptcha" class="imgCaptcha">
      <img :src="imgCaptchaAddress" alt @click="getImgCaptchaCode" />
    </div>
    <div class="code-input">
      <code-input :len="length" :isPassword="isPassword" @code-value="codeVal" ref="ci" size="50"></code-input>
    </div>
    <div class="errTip" :style="'width:' + length * 50 + 'px'">{{ errTip }}</div>
    <div v-if="errorTip" class="errTip" :style="'width:' + length * 50 + 'px'">{{ errorTip }}</div>
    <div class="notifyTip">{{ notifyTip }}</div>
    <div class="successIcon" v-if="ok">
      <icon class="success" name="icon-dingdan-yiquxiao" :myStyle="successIcon"></icon>
    </div>
    <div class="pending" v-if="pending">
      <loading size="33px"></loading>
    </div>
    <alert-vc :aVisible="alertContent" :aContent="alertContent" v-on:clickOk="alertClickOk"></alert-vc>
  </div>
  <not-logged v-else></not-logged>
</template>

<script>
import userService from '../../../service/user'
import notLogged from '../../../component/not_logged'
import alertVc from '../../../component/alert'
import codeInput from '../../../component/code_input.vue'
import iconVc from '../../../component/icon'
import account from '../../../lib/account'
import loadingVc from '../../../component/loading.vue'
import CONSTANT from '../../../constant'
import cookie from '../../../lib/cookie'
import { app } from '../../../util/platform'
import { Toast } from 'mint-ui'
import _ from 'underscore'
import setDocumentTitle from '@util/document-title'
import userManager from '@util/userManager'

const INPUT_SMS_CODE = '输入短信验证码'
const INPUT_SECURITY_CODE = '输入支付密码'
const INPUT_SECURITY_CODE_AGAIN = '再次输入支付密码'
const PWD_LENGTH_INVALID = '请输入6位数字密码'
const INPUT_IMG_CATPCHA_CODE = '输入图形验证码'
const PWD_NOT_EQUEAL = '两次密码输入不一致'
const mobileSeparationReg = /^(\d{0,3})(\d{0,4})(\d{0,4})/m
const FIRST_TIME_SEND_SMS_CODE = '已发送至:'
const INIT_CODE_LEN = 6
const pwdReg = /^((\d)|[a-zA-Z]|_){6,20}$/
const INPUT_GRAPH_CODE = 6007
const GRAPH_CODE_ERR = 6006

export default {
  components: {
    'not-logged': notLogged,
    'alert-vc': alertVc,
    'code-input': codeInput,
    icon: iconVc,
    loading: loadingVc,
  },
  data() {
    return {
      isLogged: account.isLogged(),
      isShowImgCaptcha: false,
      imgCaptchaAddress: '',
      imgCaptchaKey: '',
      length: 6,
      alertContent: '',
      isPassword: 0,
      imgCaptchaCode: '',
      value: '',
      smsCode: '',
      errTip: '',
      notifyTip: '',
      ok: false,
      pending: false,
      paypwd: '',
      rePaypwd: '',
      mobile: userManager.getMobile(),
      notifyText: FIRST_TIME_SEND_SMS_CODE,
      step: 2, //1:图形验证码 2:短信验证码 3:输入密码 4:再次输入密码
      successIcon: {
        'font-size': '43px',
        color: 'rgb(85, 175, 60)',
      },
    }
  },
  computed: {
    isAPP() {
      this.className2 = ''
      return app.isMZMall()
    },
    tipText: function () {
      return this.isShowImgCaptcha ? INPUT_IMG_CATPCHA_CODE : INPUT_SMS_CODE
    },
    errorTip: function () {
      if (!this.paypwd || !this.rePaypwd) {
        return ''
      }
      if (this.paypwd.length !== 6 || !pwdReg.test(this.paypwd)) {
        this.step = 3
        this.paypwd = ''
        this.rePaypwd = ''
        return PWD_LENGTH_INVALID
      }
      if (this.paypwd !== this.rePaypwd) {
        this.step = 3
        this.paypwd = ''
        this.rePaypwd = ''
        return PWD_NOT_EQUEAL
      }
      return ''
    },
    canSubmit: function () {
      return (
        (this.smsCode + '').length !== 0 &&
        this.paypwd === this.rePaypwd &&
        pwdReg.test(this.paypwd) &&
        (this.isShowImgCaptcha ? (this.imgCaptchaCode + '').length !== 0 : true)
      )
    },
  },
  mounted() {
    setDocumentTitle('更换手机号码')
    // 获取验证码,渲染验证码已发送
    userService
      .sendSmsCode({
        type: CONSTANT.USER_SMS_CODE_TYPE_IS_SET_PHONE,
        mobile: this.mobile,
        operatorId: Number(cookie(CONSTANT.COOKIE_KAOP_OPERATION_ID)) || 0,
      })
      .then((data) => {
        // console.log(data);
        if (data.status === 0) {
          this.notifyTip = `${FIRST_TIME_SEND_SMS_CODE}${this.mobile}`
        } else if (data.status === INPUT_GRAPH_CODE) {
          this.isShowImgCaptcha = true
          this.getImgCaptchaCode()
        } else {
          Toast({
            message: data.msg,
            position: 'bottom',
            duration: 2000,
          })
        }
      })
      .catch((err) => {})
  },
  methods: {
    alertClickOk: function () {
      this.alertContent = ''
    },
    goBack() {
      this.$router.go(-1)
      //this.$router.push("/user/change_phone");
    },
    codeVal: function (val) {
      this.value = val
    },
    getImgCaptchaCode: function () {
      const self = this
      userService
        .getImgCaptcha()
        .then((data) => {
          self.imgCaptchaAddress = data.imgUrl
          self.imgCaptchaKey = data.imgKey
          self.length = data.length
        })
        .catch((e) => {
          self.alertContent = e.msg
        })
    },
    reset: function () {
      const self = this
      self.$refs.ci.reset()
      self.value = ''
    },
    getSmsCaptchaCode: function () {
      const self = this
      self.pending = true
      let sep = self.mobile.match(mobileSeparationReg)
      sep.shift()
      let m = _.compact(sep).join(' ')
      userService
        .sendSmsCode({
          type: CONSTANT.USER_SMS_CODE_TYPE_IS_SET_SECURITY_CODE,
          mobile: String(self.mobile),
          imgKey: self.imgCaptchaKey,
          imgCode: self.value,
          operatorId: Number(cookie(CONSTANT.COOKIE_KAOP_OPERATION_ID)) || 0,
        })
        .then(() => {
          self.isShowImgCaptcha = false
          self.errTip = ' '
          self.value = ''
          self.reset()
          self.length = INIT_CODE_LEN
          self.notifyTip = self.notifyText + String(m)
          self.pending = false
          setTimeout(function () {
            self.step = 2
          }, 500)
        })
        .catch((err) => {
          self.reset()
          self.errTip = err.msg
          self.pending = false
          if (err.status == GRAPH_CODE_ERR || err.status == INPUT_GRAPH_CODE) {
            self.isShowImgCaptcha = true
            self.getImgCaptchaCode()
            setTimeout(function () {
              self.step = 1
            }, 500)
          } else if (err.status == 1014) {
            self.isShowImgCaptcha = false
            self.errTip = ''
            self.value = ''
            self.length = INIT_CODE_LEN
            self.notifyTip = self.notifyText + String(m)
            self.notifyTip = notifyText + String(m)
            // ++self.step
            setTimeout(function () {
              self.step = 2
            }, 500)
          }
        })
    },
    setSecurityCode: function () {},
  },
  watch: {
    value: function () {
      const self = this
      if (this.value.length >= 1) {
        self.errTip = ''
      }
      if (this.length == 4 && this.value.length == 4) {
        this.getSmsCaptchaCode()
      } else if (this.length == 6 && this.value.length == 6 && this.step <= 4) {
        if (this.step == 2) {
          userService
            .authorize({
              type: 1,
              smsCode: this.value,
            })
            .then((data) => {
              // console.log(data);
              if (data.status === 0) {
                // console.log(data.data.authToken)
                sessionStorage.setItem(CONSTANT.CHANGE_PHONE_TOKEN, data.data.authToken)
                self.$router.push('/login/user/new_phone')
              } else {
                self.value = ''
                self.$refs.ci.reset()
                self.errTip = data.msg
              }
            })
            .catch((err) => {})
        }
      }
    },
  },
}
</script>

<style lang="less">
.verify {
  header {
    width: 100%;
    height: 44px;
    position: relative;
    background-color: #fff;

    .left {
      width: 44px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        display: block;
        width: 11px;
        height: 19px;
      }
    }
    .text {
      width: 103px;
      height: 24px;
      position: absolute;
      top: 10px;
      left: 136px;
      text-align: center;
      line-height: 24px;
      font-size: 17px;
      color: rgb(25, 26, 27);
    }
  }
  .height40 {
    height: 40px;
  }
  .tip-text {
    margin-top: 90px;
    text-align: center;
    font-size: 15px;
    color: rgb(25, 26, 27);
  }
  .code-input {
    margin: 30px auto 0;
    text-align: center;
  }
  .imgCaptcha {
    margin: 25px auto;
    text-align: center;
    img {
      height: 30px;
    }
  }
  .errTip {
    text-align: left;
    color: rgb(192, 49, 49);
    margin: 9px auto 0;
    font-size: 11px;
  }
  .notifyTip {
    text-align: center;
    color: rgb(189, 192, 197);
    margin-top: 30px;
    padding: 0 50px;
    font-size: 12px;
  }
  .successIcon {
    text-align: center;
    .success {
      font-size: 33px;
      color: rgb(85, 175, 60);
    }
  }
}
</style>
